export const SET_DATEOFBIRTH_STATE = "SET_DATEOFBIRTH_STATE";

export const showDobPopup = (payload) => {
   return {
      type: SET_DATEOFBIRTH_STATE,
      payload,
   };
};